import Model, { ID, IsoDate, JsonObject, MODEL_LEVEL } from 'src/models/model'
import SiteSchedule from 'src/models/schedule/SiteSchedule'

export function encodeLayoutSlotKey (activitySpaceId, timeSlotId, dayNumber) {
  return `${activitySpaceId},${timeSlotId},${dayNumber}`
}

export function decodeLayoutSlotKey (key) {
  const values = key.split(',')

  return {
    activitySpaceId: values[0],
    timeSlotId: values[1],
    dayNumber: values[2]
  }
}

export default class ActivityLayout extends Model {
  static name = 'ActivityLayout'

  static versioned = true

  static level = MODEL_LEVEL.SITE

  static deletable = true

  static employeeRequiredPermissionCategories = [Model.permissionCategories.NonFilmProgramming]

  static define () {
    this.fields = {
      id: {
        type: ID,
        sortable: true
      },
      name: {
        type: String,
        default: null,
        sortable: true
      },
      startDate: {
        type: IsoDate,
        default: null
      },
      endDate: {
        type: IsoDate,
        default: null
      },
      layout: {
        type: JsonObject,
        default: () => { return {} }
      },
      layoutMap: {
        type: Object,
        local: true,
        trackChanges: true,
        default: () => { return {} }
      },
      previewLayout: {
        type: Object,
        local: true,
        default: () => { return {} }
      },
      previewingAction: {
        type: Boolean,
        local: true,
        default: false
      },
      defaultSiteSchedule: {
        type: SiteSchedule,
        output: true
      }
    }

    this.computed = {
      displayLayout () {
        return this.buildDisplayLayout()
      }
    }

    this.paginate = true
  }

  isSiteOpen (timeSlotId, dayNumber) {
    if (this.isLocal) {
      const defaultSiteSchedule = _(this.configuration.siteSchedules.data).filter(siteSchedule => {
        return siteSchedule.startDate <= this.startDate && siteSchedule.endDate >= this.startDate
      }).first()

      return defaultSiteSchedule?.schedule?.[timeSlotId]?.[dayNumber]
    } else {
      return this.defaultSiteSchedule?.schedule?.[timeSlotId]?.[dayNumber]
    }
  }

  buildDisplayLayout () {
    if (this.previewingAction) {
      return this.previewLayout || {}
    } else {
      return this.layoutMap || {}
    }
  }

  buildLayoutFromLayoutMap () {
    const layout = {}

    _.each(this.layoutMap, (layoutSlot, key) => {
      if (!layoutSlot) {
        return
      }

      const value = {
        activityId: layoutSlot.activity?.id
      }

      layout[key] = value
    })

    this.layout = layout
  }

  encode () {
    if (this.layoutMap) {
      this.buildLayoutFromLayoutMap()
    }

    return this.data
  }

  afterInflate () {
    this.inflateLayoutMapFromLayout()
  }

  inflateLayoutMapFromLayout () {
    const layout = {}

    _.each(this.layout, (layoutSlot, key) => {
      if (!layoutSlot) {
        return
      }

      const { activitySpaceId, timeSlotId, dayNumber } = decodeLayoutSlotKey(key)
      const activity = _.find(this.configuration.activities.data, { id: +layoutSlot.activityId })

      layout[encodeLayoutSlotKey(activitySpaceId, timeSlotId, dayNumber)] = { activity }
    })

    this.layoutMap = layout
  }
}
